import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { useDocumentTitle } from "@/hooks/use-document-title";

import { TrashPage } from "../components/trash-page";
import { TrashScope } from "../hooks/api/trash.gql";

export function DataRequestTrashPage() {
  const { t } = useTranslation("trash");
  useDocumentTitle(t("trashTab"));

  return (
    <FeatureFlagToggle flag="enable-trash" fallback={<Navigate to=".." relative="path" replace />}>
      <TrashPage scope={TrashScope.MINE} entityType="dataRequest" />
    </FeatureFlagToggle>
  );
}
